import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=a4ddcf9e&"
import script from "./Fullscreen.vue?vue&type=script&lang=js&"
export * from "./Fullscreen.vue?vue&type=script&lang=js&"
import style0 from "./Fullscreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports